import { PropsWithChildren } from 'react';
import { OptInToSmsCheckbox } from '~/components/inputs/opt-in-to-sms-checkbox';
import { AccountEntityName } from './account-entity-name';
import { Address } from './address';
import { AddressSecondary } from './address-secondary';
import { AgentName } from './agent-name';
import { BillingAddressCheckbox } from './billing-address-checkbox';
import { BudgetBillingCheckbox } from './budget-billing-checkbox';
import { BusinessName } from './business-name';
import { DateOfBirth } from './date-of-birth';
import { Email } from './email';
import { EmailTelesales } from './email-telesales';
import { EstimatedAnnualKwh } from './estimated-annual-kwh';
import { EstimatedDailyKwh } from './estimated-daily-kwh';
import { EstimatedMonthlyKwh } from './estimated-monthly-kwh';
import { FirstName } from './first-name';
import { InviteCode } from './invite-code';
import { JobTitle } from './job-title';
import { LastName } from './last-name';
import { MeterNumber } from './meter-number';
import { NameKeyForEdi } from './name-key-for-edi';
import { NameOnDocument } from './name-on-document';
import { OnboardingRateClassSelect } from './onboarding-rate-class-select';
import { Password } from './password';
import { Phone } from './phone';
import { PromoCode } from './promo-code';
import { SecondaryIdentifier } from './secondary-identifier';
import { StripePaymentId, StripeCustomerId } from './stripe-payment';
import { UtilityAccountNumber } from './utility-account-number';
import { UtilityEmail } from './utility-email';
import { UtilityPassword } from './utility-password';
import { UtilityUsername } from './utility-username';
import { ZipCode } from './zip-code';

export const Inputs = ({ children }: PropsWithChildren<{}>) => children;

Inputs.AccountEntityName = AccountEntityName;
Inputs.Address = Address;
Inputs.AddressSecondary = AddressSecondary;
Inputs.AgentName = AgentName;
Inputs.BillingAddressCheckbox = BillingAddressCheckbox;
Inputs.BudgetBillingCheckbox = BudgetBillingCheckbox;
Inputs.BillingAddressCheckbox = BillingAddressCheckbox;
Inputs.BusinessName = BusinessName;
Inputs.DateOfBirth = DateOfBirth;
Inputs.Email = Email;
Inputs.EmailTelesales = EmailTelesales;
Inputs.EstimatedAnnualKwh = EstimatedAnnualKwh;
Inputs.EstimatedDailyKwh = EstimatedDailyKwh;
Inputs.EstimatedMonthlyKwh = EstimatedMonthlyKwh;
Inputs.FirstName = FirstName;
Inputs.InviteCode = InviteCode;
Inputs.JobTitle = JobTitle;
Inputs.LastName = LastName;
Inputs.MeterNumber = MeterNumber;
Inputs.NameKeyForEdi = NameKeyForEdi;
Inputs.NameOnDocument = NameOnDocument;
Inputs.Password = Password;
Inputs.Phone = Phone;
Inputs.OptInToSmsCheckbox = OptInToSmsCheckbox;
Inputs.PromoCode = PromoCode;
Inputs.OnboardingRateClassSelect = OnboardingRateClassSelect;
Inputs.UtilityAccountNumber = UtilityAccountNumber;
Inputs.SecondaryIdentifier = SecondaryIdentifier;
Inputs.StripePaymentId = StripePaymentId;
Inputs.StripeCustomerId = StripeCustomerId;
Inputs.UtilityUsername = UtilityUsername;
Inputs.UtilityEmail = UtilityEmail;
Inputs.UtilityPassword = UtilityPassword;
Inputs.ZipCode = ZipCode;
